import React, { useState } from "react";
import styles from "./MobileMenu.module.scss";
import { NavLink, useNavigate } from "react-router-dom";

// Properties
import properties from "properties.json";

// Assets
import EEPLogo from "assets/images/png/EEP-Logo.png";
import { ieeeLogo } from "helpers/icons";

// Icons
import { arrowDownIcon, closeIcon } from "helpers/icons";

const MobileMenu = ({ openMobileMenu, setOpenMobileMenu }) => {
  const navigate = useNavigate();
  const [isDropDownOpened, setIsDropDownOpened] = useState(false);

  const activeClassName = styles.active;

  return (
    <div className={styles.menuWrapper}>
      <div
        className={`${styles.mobileMenu} ${openMobileMenu && styles.opemMenu}`}
      >
        <div
          className={styles.closeBtn}
          onClick={() => setOpenMobileMenu(false)}
        >
          {closeIcon()}
        </div>
        <div className={styles.logo} onClick={() => navigate("/")}>
          {ieeeLogo(0.7)}
        </div>
        <div className={styles.nav}>
          <NavLink
            className={({ isActive }) =>
              styles.navItem + " " + (isActive ? activeClassName : undefined)
            }
            to="/"
          >
            <span>Home</span>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              styles.navItem + " " + (isActive ? activeClassName : undefined)
            }
            to="/about"
          >
            <span>About</span>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              styles.navItem + " " + (isActive ? activeClassName : undefined)
            }
            to="/team"
          >
            <span>Team</span>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              styles.navItem + " " + (isActive ? activeClassName : undefined)
            }
            to="/events"
          >
            <span>Events</span>
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              styles.navItem + " " + (isActive ? activeClassName : undefined)
            }
            to="/forms"
          >
            <span>Forms</span>
          </NavLink>
        </div>

        <div className={styles.footerMessage}>
          2025 IEEE | All Rights Reserved <br />
          Developed by
          <a href="https://portfolio-psi-two-81.vercel.app/" target="_blank" rel="noreferrer">
            Mohamed Samy
          </a>
        </div>
      </div>
      <div
        className={`${styles.menuOverlay} ${openMobileMenu && styles.opemMenu}`}
        onClick={() => setOpenMobileMenu(false)}
      />
    </div>
  );
};

export default MobileMenu;
